"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchedulingFlowStagesEnum = void 0;
/**
 * Enums for the individual scheduling flow stages
 */
var SchedulingFlowStagesEnum = /*#__PURE__*/function (SchedulingFlowStagesEnum) {
  SchedulingFlowStagesEnum["BOOKING_VISIT_REASON"] = "booking-visit-reason";
  SchedulingFlowStagesEnum["THERAPY_FREQUENCY"] = "therapy-frequency";
  SchedulingFlowStagesEnum["SCHEDULE_THERAPY"] = "schedule-therapy";
  SchedulingFlowStagesEnum["SCHEDULE_PHYSICIAN"] = "schedule-physician";
  SchedulingFlowStagesEnum["REVIEW_INTAKE"] = "review-intake";
  SchedulingFlowStagesEnum["INTAKE"] = "intake";
  SchedulingFlowStagesEnum["SCHEDULING_PAYMENT"] = "scheduling-payment";
  SchedulingFlowStagesEnum["PAYMENT_SUCCESS"] = "payment-success";
  SchedulingFlowStagesEnum["COMPLETE"] = "complete";
  SchedulingFlowStagesEnum["EXITED"] = "exited";
  return SchedulingFlowStagesEnum;
}({});
exports.SchedulingFlowStagesEnum = SchedulingFlowStagesEnum;